import { apiClient } from '@/services/'

export const namespaced = true

export const state = {
  loadingSchedule: false,
  studentSchedule: [],
}

export const mutations = {
  SET_LOADING_SCHEDULE(state, status) {
    state.loadingSchedule = status
  },
  SET_SCHEDULE(state, status) {
    state.studentSchedule = status
  },
}

export const actions = {
  getStudentSchedule({ commit, rootState }) {
    commit('SET_LOADING_SCHEDULE', true)
    const { thisMonday } = rootState
    return apiClient
      .get('/StudSched', {
        params: {
          sAdName: rootState.adName,
          weekStartDateTime: thisMonday,
        },
      })
      .then((response) => {
        const formatted = response.data.map((item) => {
          return {
            name: item.name,
            start: item.start,
            end: item.end,
            location: item.location,
            details: {
              Period: item.period,
              Room: item.room,
              Staff: item.staff,
            },
          }
        })
        commit('SET_SCHEDULE', formatted)
        commit('SET_LOADING_SCHEDULE', false)
      })
  },
}
